export default "__VITE_ASSET__BOHXd3DV__"